export const setCurrentStepRegistrationAction = (currentStep) => ({
  type: "CHANGE_STEP_REGISTRATION",
  payload: {
    currentStep
  }
});

export const setLastStepRegistrationAction = (lastStep) => ({
  type: "CHANGE_LAST_STEP_REGISTRATION",
  payload: {
    lastStep
  }
});

export const setIsEditingRegistrationAction = (isEditing) => ({
  type: "SET_IS_EDITING_REGISTRATION",
  payload: {
    isEditing
  }
});

export const setAPromotionRegistrationAction = (promoId, promoBody) => ({
  type: "SET_A_PROMOTION_REGISTRATION",
  payload: {
    promoId,
    promoBody
  }
});

export const setSelectedPromotionRegistrationAction = (promoId) => ({
  type: "SET_A_SELECTED_PROMOTION_REGISTRATION",
  payload: {
    promoId
  }
});

export const setWelcomeFieldsRegistrationAction = (fields) => ({
  type: "SET_WELCOME_FIELDS_REGISTRATION",
  payload: {
    fields
  }
});

export const setWelcomeBirthRegistrationAction = (birth) => ({
  type: "SET_WELCOME_BIRTH_REGISTRATION",
  payload: {
    birth
  }
});

export const setWelcomeValidFormRegistrationAction = (isValid) => ({
  type: "SET_WELCOME_VALID_FORM_REGISTRATION",
  payload: {
    isValid
  }
});

export const setAddressFieldsRegistrationAction = (fields) => ({
  type: "SET_ADDRESS_FIELDS_REGISTRATION",
  payload: {
    fields
  }
});

export const setLocationAddressFieldsRegistrationAction = (fields) => ({
  type: "SET_LOCATION_ADDRESS_FIELDS_REGISTRATION",
  payload: {
    fields
  }
});

export const setSsnFieldsRegistrationAction = (fields) => ({
  type: "SET_SSN_FIELDS_REGISTRATION",
  payload: {
    fields
  }
});

export const setAddressValidFormRegistrationAction = (isValid) => ({
  type: "SET_ADDRESS_VALID_FORM_REGISTRATION",
  payload: {
    isValid
  }
});

export const setSsnValidFormRegistrationAction = (isValid) => ({
  type: "SET_SSN_VALID_FORM_REGISTRATION",
  payload: {
    isValid
  }
});

export const setFullSsnValidFormRegistrationAction = (isValid) => ({
  type: "SET_FULL_SSN_VALID_FORM_REGISTRATION",
  payload: {
    isValid
  }
});

export const setAddressInfoScreenAction = ({
  isOpen,
  status,
  state,
  ageLimit,
  redirectUrl
}) => ({
  type: "SET_ADDRESS_INFO_SCREEN_REGISTRATION",
  payload: { status, isOpen, state, ageLimit, redirectUrl }
});

export const handleErrorModalRegistrationAction = ({ isOpen, status }) => ({
  type: "HANDLE_ERROR_MODAL_REGISTRATION",
  payload: { isOpen, status }
});

export const handlePromoCodeModalRegistrationAction = (isOpen) => ({
  type: "HANDLE_PROMO_CODE_MODAL_REGISTRATION",
  payload: {
    isOpen
  }
});

export const setInvalidPromoRegistrationAction = (invalidPromo) => ({
  type: "SET_INVALID_PROMO_REGISTRATION",
  payload: {
    invalidPromo
  }
});

export const handleTvPreferencesModalRegistrationAction = (isOpen) => ({
  type: "HANDLE_TV_PREFERENCES_MODAL_REGISTRATION",
  payload: {
    isOpen
  }
});

export const setTvPreferencesScreenRegistrationAction = (selectedProvider) => ({
  type: "SET_TV_PREFERENCES_SCREEN_REGISTRATION",
  payload: {
    selectedProvider
  }
});

export const cleanRegistrationAction = () => ({
  type: "CLEAN_REGISTRATION"
});

export const setPassThroughAddressAction = (value) => ({
  type: "SET_PASS_THROUGH_ADDRESS",
  payload: {
    value
  }
});

export const handleLegalContentModalRegistrationAction = ({
  isOpen,
  contentType
}) => ({
  type: "HANDLE_LEGAL_CONTENT_MODAL_REGISTRATION",
  payload: {
    isOpen,
    contentType
  }
});

export const setLegalContentModalOriginRegistrationAction = (contentType) => ({
  type: "SET_LEGAL_CONTENT_MODAL_ORIGIN_REGISTRATION",
  payload: {
    modalOrigin: contentType
  }
});

export const setOnfidoDetailsRegistrationAction = (onfidoDetails) => ({
  type: "SET_ONFIDO_DETAILS_REGISTRATION",
  payload: onfidoDetails
});

export const setHasValidatedOnfidoRegistrationAction = (
  hasValidatedOnfido
) => ({
  type: "SET_VALIDATED_ONFIDO_REGISTRATION",
  payload: hasValidatedOnfido
});
